<template>
  <div class="devlist-page">
    <div class="bg-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
    </div>

    <van-pull-refresh v-model="isLoading" @refresh="onReflash" class="devlist-index">
      <div class="page-header">
        <div class="header-row">
          <svg width="20" height="20" viewBox="0 0 28 28" fill="none" class="header-icon-sm">
            <rect x="3" y="5" width="22" height="18" rx="3" stroke="#2dd4bf" stroke-width="1.8" opacity="0.35" />
            <rect x="6" y="8" width="16" height="12" rx="2" stroke="#2dd4bf" stroke-width="1.8" />
            <circle cx="14" cy="14" r="2.5" fill="#2dd4bf" opacity="0.7" />
            <line x1="14" y1="11.5" x2="14" y2="16.5" stroke="#2dd4bf" stroke-width="1.2" opacity="0.5" />
            <line x1="11.5" y1="14" x2="16.5" y2="14" stroke="#2dd4bf" stroke-width="1.2" opacity="0.5" />
          </svg>
          <h1 class="page-title">设备主页</h1>
          <span class="page-count">{{ devlistdata.length }} 台</span>
        </div>
      </div>

      <van-sticky>
        <div class="top-bar">
          <div class="top-row">
            <div class="group-selector" @click="seletegroup">
              <span class="iconfont icon-liebiao1 group-icon"></span>
              <span class="group-text">{{ group_select_name || '所有设备' }}</span>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M3 4.5L6 7.5L9 4.5" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>

            <div class="top-actions">
              <button v-if="isWechatMiniProgram == true" class="action-btn action-btn--primary" @click="xcx_ble()">
                搜索蓝牙
              </button>
              <button v-if="isWechatMiniProgram == true" class="action-btn action-btn--primary" @click="xcx_blufi()">
                绑定设备
              </button>
              <button v-if="isWechatMiniProgram == false" class="action-btn action-btn--primary"
                @click="binddialog = true">
                添加设备
              </button>
            </div>
          </div>

          <div class="filter-row">
            <span class="filter-chip" :class="only_online ? 'filter-chip--active' : 'filter-chip--inactive'"
              @click="set_only_online(!only_online)">只看在线</span>

            <span class="filter-chip" :class="time_reverse ? 'filter-chip--active' : 'filter-chip--inactive'"
              @click="set_time_reverse(!time_reverse)">时间倒序</span>

            <span class="filter-chip" :class="show_id ? 'filter-chip--active' : 'filter-chip--inactive'"
              @click="set_show_id(!show_id)">显示ID</span>

            <span class="filter-chip" :class="show_simple ? 'filter-chip--active' : 'filter-chip--inactive'"
              @click="set_show_simple(!show_simple)">显示缩略图</span>
          </div>
        </div>
      </van-sticky>

      <div class="dev-list-area">
        <div v-for="devdata in devlistdata" v-bind:key="devdata.did">
          <div v-if="devdata.d_type === 'KD-1'">
            <DevCardKD1 v-bind:devdata="devdata" @cardflash="cardflash($event)"></DevCardKD1>
          </div>
          <div v-if="devdata.d_type === 'KD-5'">
            <DevCardKD5 v-bind:devdata="devdata" @cardflash="cardflash($event)"></DevCardKD5>
          </div>
          <div v-if="devdata.d_type === 'KA-1'">
            <DevCardKA1 v-bind:devdata="devdata" @cardflash="cardflash($event)"></DevCardKA1>
          </div>
          <div v-if="devdata.d_type === 'KD-2'">
            <DevCardKD2 v-bind:devdata="devdata" @cardflash="cardflash($event)"></DevCardKD2>
          </div>
          <div v-if="devdata.d_type === 'KD-3'">
            <DevCardKD3 v-bind:devdata="devdata" @cardflash="cardflash($event)"></DevCardKD3>
          </div>
          <div v-if="devdata.d_type === 'KD-6'">
            <DevCardKD6 v-bind:devdata="devdata" @cardflash="cardflash($event)"></DevCardKD6>
          </div>
          <div v-if="devdata.d_type === 'KS-1'">
            <DevCardKS1 v-bind:devdata="devdata" @cardflash="cardflash($event)"></DevCardKS1>
          </div>
          <div v-if="devdata.d_type === 'KS-2'">
            <DevCardKS2 v-bind:devdata="devdata" @cardflash="cardflash($event)"></DevCardKS2>
          </div>
          <div v-if="devdata.d_type === 'KD-4'">
            <DevCardKD4 v-bind:devdata="devdata" @cardflash="cardflash($event)"></DevCardKD4>
          </div>
        </div>

        <div v-if="devlistdata.length === 0" class="empty-state">
          <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
            <rect x="10" y="12" width="36" height="32" rx="6" stroke="#cbd5e1" stroke-width="2" opacity="0.5" />
            <circle cx="28" cy="28" r="6" stroke="#cbd5e1" stroke-width="2" opacity="0.5" />
            <line x1="20" y1="12" x2="20" y2="44" stroke="#cbd5e1" stroke-width="1.5" opacity="0.3" />
            <line x1="36" y1="12" x2="36" y2="44" stroke="#cbd5e1" stroke-width="1.5" opacity="0.3" />
          </svg>
          <p class="empty-text">暂无设备</p>
        </div>
      </div>

    </van-pull-refresh>

    <van-tabbar route class="crystal-tabbar">
      <van-tabbar-item icon="home-o" to="/devlist" replace>主页</van-tabbar-item>
      <van-tabbar-item icon="setting-o" to="/group" replace>设备管理</van-tabbar-item>
      <van-tabbar-item icon="friends-o" to="/user" replace>账户</van-tabbar-item>
    </van-tabbar>

    <van-popup v-model="gloupseletshow" position="bottom" round class="crystal-popup">
      <div class="group-select-popup">
        <h3 class="popup-title">选择分组</h3>
        <van-tree-select :items="groupitems" :active-id.sync="activeId" :main-active-index.sync="activeIndex"
          @click-item="clickitem" />
      </div>
    </van-popup>

    <van-dialog v-model="binddialog" title="绑定设备" show-cancel-button :beforeClose="handleClose"
      class-name="crystal-dialog">
      <div class="dialog-body">
        <label class="dialog-label">设备ID</label>
        <div class="dialog-input-wrap">
          <van-field v-model="did" placeholder="请输入设备ID号" input-class="dialog-field" />
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import DevCardKD1 from "./../components/kd1/DevCardKD1.vue";
import DevCardKD5 from "./../components/kd5/DevCardKD5.vue";
import DevCardKA1 from "./../components/ka1/DevCardKA1.vue";
import DevCardKD2 from "./../components/kd2/DevCardKD2.vue";
import DevCardKD3 from "./../components/kd3/DevCardKD3.vue";
import DevCardKS1 from "./../components/ks1/DevCardKS1.vue";
import DevCardKS2 from "./../components/ks2/DevCardKS2.vue";
import DevCardKD4 from "./../components/kd4/DevCardKD4.vue";
import DevCardKD6 from "./../components/kd6/DevCardKD6.vue";

export default {
  name: "devlist",
  components: {
    DevCardKD1,
    DevCardKD5,
    DevCardKA1,
    DevCardKD2,
    DevCardKD3,
    DevCardKS1,
    DevCardKS2,
    DevCardKD4,
    DevCardKD6,
  },
  data() {
    return {
      did: "",
      only_online: this.$store.state.only_online,
      time_reverse: this.$store.state.time_reverse,
      show_id: this.$store.state.show_id,
      show_simple: this.$store.state.show_simple,
      binddialog: false,
      isLoading: false,
      gloupseletshow: false,
      groupitems: [],
      activeId: 0,
      activeIndex: 0,
      devlistdata: [],
      group_select: "",
      group_select_name: "",
      isWechatMiniProgram: false,
      is_login: false,
      url_openid: this.$route.query.openid
    };
  },
  mounted() {
    //console.log(this.openid)

    this.isWechatMiniProgram = this.$store.state.is_xcx;
    this.group_select = this.$store.state.group_id;
    this.group_select_name = this.$store.state.group_name;

    if (this.url_openid) {
      this.$store.commit('set_openid', this.url_openid);
      //console.log("this.$store.state.openid: ", this.$store.state.openid);
    }

    this.group_list();
    this.dev_list(this.group_select);
  },
  methods: {
    xcx_ble() {
      //if (typeof wx !== 'undefined' && wx.miniProgram) 
      if (this.$store.state.is_xcx) {
        wx.miniProgram.navigateTo({
          url: '/pages/search/search'
        });
      }
    },
    xcx_blufi() {
      if (this.is_login === false) {
        this.$router.push({
          path: '/login',
          name: 'login'
        })
        return;
      }
      //if (typeof wx !== 'undefined' && wx.miniProgram) 
      if (this.$store.state.is_xcx) {
        wx.miniProgram.navigateTo({
          url: '/pages/blufi/blufi/blufi'
        });
      }
    },
    set_only_online(only_online) {
      this.$store.commit('set_only_online', only_online);
      this.only_online = only_online;
    },
    set_time_reverse(time_reverse) {
      this.$store.commit('set_time_reverse', time_reverse);
      this.time_reverse = time_reverse;
      this.devlistdata.reverse();
    },
    set_show_id(show_id) {
      this.$store.commit('set_show_id', show_id);
      this.show_id = show_id;
    },
    set_show_simple(show_simple) {
      this.$store.commit('set_show_simple', show_simple);
      this.show_simple = show_simple;
    },
    handleClose(action, done) {
      if (action === "confirm") {
        done();
        this.devbind(this.did, "");
      } else if (action === "cancel") {
        done();
      }
    },
    devbind(did, gid) {
      const qs = require("qs");
      this.$axios
        .post(
          "/api/dev/bind",
          qs.stringify({
            gid: gid,
            did: did
          })
        )
        .then((response) => {
          if (response.data.error_code === 0) {
            this.$notify({
              type: "success",
              message: "绑定成功！"
            });
            this.dev_list(this.group_select);
          } else if (response.data.error_code === 401) {
            this.$notify({
              type: "warning",
              message: "设备已经绑定"
            });
          } else if (response.data.error_code === 402 || response.data.error_code === 408) {
            this.$notify({
              type: "warning",
              message: "设备ID错误或处于不可绑定状态"
            });
          } else if (response.data.error_code === 301) {
            this.$router.push({
              path: "/login",
              name: "login"
            });
          } else {
            this.$notify({
              type: "danger",
              message: "绑定失败"
            });
          }
        })
        .catch((error) => { });
    },
    cardflash(msg) {
      this.dev_list(this.group_select);
    },
    seletegroup() {
      this.gloupseletshow = true;
    },
    clickitem(data) {
      this.gloupseletshow = false;
      this.$store.commit('set_gid', {
        gid: data.id,
        gname: data.text
      });
      this.group_select = this.$store.state.group_id;
      this.group_select_name = this.$store.state.group_name;
      this.group_list();
      this.dev_list(this.group_select);
    },
    group_list() {
      const qs = require("qs");
      this.$axios
        .post("api/group/list", qs.stringify({
          a: 1
        }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.groupitems = this.get_group_list(response.data.grouplist);
          } else if (response.data.error_code === 301 && this.isWechatMiniProgram === false) {
            console.log("group_list", this.isWechatMiniProgram)
            this.$router.push({
              path: "/login",
              name: "login"
            });
          }
        })
        .catch((error) => { });
    },

    dev_list(gid) {
      const qs = require("qs");
      this.$axios
        .post(
          "/api/dev/list",
          qs.stringify({
            gid: gid
          })
        )
        .then((response) => {
          if (response.data.error_code === 0) {
            this.devlistdata = response.data.devlist;
            this.is_login = true
            if (this.time_reverse)
              this.devlistdata.reverse();
          } else if (response.data.error_code === 301) {
            this.is_login = false
            if (this.isWechatMiniProgram === false) {
              this.$router.push({
                path: "/login",
                name: "login"
              });
            }

          }
        })
        .catch((error) => { });
    },
    onReflash() {
      this.group_list();
      this.cardflash();
      this.isLoading = false;
    },
    get_group_list(grouplist) {
      var buf = [{
        text: "所有设备",
        children: [{
          text: "所有设备",
          id: ""
        }],
      }];
      for (let i in grouplist) {
        var fbuf = {};
        fbuf.id = grouplist[i].gid;
        fbuf.text = grouplist[i].group + "(" + grouplist[i].devnum + ")";
        if (grouplist[i].nextgplist.length != 0) {
          fbuf.children = [{
            text: grouplist[i].group,
            id: grouplist[i].gid
          }];
          for (let t in grouplist[i].nextgplist) {
            var nbuf = {};
            nbuf.id = grouplist[i].nextgplist[t].gid;
            nbuf.text = grouplist[i].nextgplist[t].group + "(" + grouplist[i].nextgplist[t].devnum + ")";
            fbuf.children.push(nbuf);
          }
        } else {
          fbuf.children = [{
            text: grouplist[i].group,
            id: grouplist[i].gid
          }];
        }
        buf.push(fbuf);
      }
      return buf;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;600;700&display=swap");

.van-tabbar.crystal-tabbar {
  border-top: 1px solid #f1f5f9;
  background: #ffffff;
  box-shadow: 0 -2px 16px rgba(0, 0, 0, 0.04);
}

.crystal-tabbar .van-tabbar-item--active {
  color: #2dd4bf !important;
}

.crystal-tabbar .van-tabbar-item__icon {
  font-size: 22px;
}

.crystal-tabbar .van-tabbar-item__text {
  font-size: 11px;
  font-weight: 500;
}

.van-dialog.crystal-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  font-family: "Inter", "Noto Sans SC", sans-serif;
}

.crystal-dialog .van-dialog__header {
  font-size: 17px;
  font-weight: 600;
  color: #1e293b;
  padding-top: 24px;
  font-family: inherit;
}

.crystal-dialog .van-dialog__confirm,
.crystal-dialog .van-dialog__confirm:active {
  color: #2dd4bf !important;
}

.crystal-dialog .van-dialog__cancel {
  color: #94a3b8;
}

.crystal-dialog .van-hairline--top {
  border-color: #f1f5f9;
}

.crystal-popup {
  font-family: "Inter", "Noto Sans SC", sans-serif;
}
</style>

<style scoped>
.devlist-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(145deg, #f0f9ff 0%, #fdf2f8 35%, #f0fdf4 100%);
  font-family: "Inter", "Noto Sans SC", sans-serif;
  position: relative;
  overflow: hidden;
}

.bg-shapes {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.shape {
  position: absolute;
  border-radius: 50%;
}

.shape-1 {
  width: 320px;
  height: 320px;
  background: radial-gradient(circle, rgba(45, 212, 191, 0.1) 0%, transparent 70%);
  top: -100px;
  right: -50px;
  animation: shapeDrift 20s ease-in-out infinite alternate;
}

.shape-2 {
  width: 240px;
  height: 240px;
  background: radial-gradient(circle, rgba(251, 113, 133, 0.06) 0%, transparent 70%);
  bottom: 120px;
  left: -60px;
  animation: shapeDrift 18s ease-in-out infinite alternate-reverse;
}

.shape-3 {
  width: 160px;
  height: 160px;
  background: radial-gradient(circle, rgba(167, 139, 250, 0.05) 0%, transparent 70%);
  top: 45%;
  right: -30px;
  animation: shapeDrift 22s ease-in-out infinite alternate;
}

.shape-4 {
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(251, 191, 36, 0.04) 0%, transparent 70%);
  bottom: 40%;
  left: -50px;
  animation: shapeDrift 16s ease-in-out infinite alternate-reverse;
}

@keyframes shapeDrift {
  0% {
    transform: translate(0, 0) scale(1);
  }

  100% {
    transform: translate(30px, -20px) scale(1.1);
  }
}

.devlist-index {
  position: relative;
  z-index: 1;
  background: transparent !important;
  padding-bottom: 50px;
  min-height: 100vh;
  min-height: 100dvh;
  animation: pageEnter 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes pageEnter {
  from {
    opacity: 0;
    transform: translateY(12px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.page-header {
  padding: 12px 16px 8px;
}

.header-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-icon-sm {
  display: block;
  flex-shrink: 0;
}

.page-title {
  font-weight: 700;
  font-size: 18px;
  color: #1e293b;
  margin: 0;
  letter-spacing: 0.3px;
}

.page-count {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 400;
  margin-left: auto;
}

.top-bar {
  background: #ffffff;
  border-radius: 18px;
  margin: 0 12px 12px;
  padding: 12px 14px 10px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
}

.top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.group-selector {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 8px 14px;
  cursor: pointer;
  transition: border-color 0.2s;
  flex: 1;
  min-width: 0;
  margin-right: 10px;
}

.group-selector:active {
  border-color: #2dd4bf;
}

.group-icon {
  font-size: 16px;
  color: #2dd4bf;
  flex-shrink: 0;
}

.group-text {
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.top-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.action-btn {
  height: 36px;
  padding: 0 14px;
  border: none;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  font-family: inherit;
  transition: transform 0.15s;
}

.action-btn:active {
  transform: scale(0.95);
}

.action-btn--primary {
  background: linear-gradient(135deg, rgba(45, 212, 191, 0.15), rgba(45, 212, 191, 0.25));
  color: #0d9488;
}

.filter-row {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.filter-chip {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 14px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;
  user-select: none;
}

.filter-chip--active {
  background: #2dd4bf;
  color: #fff;
}

.filter-chip--inactive {
  background: #f1f5f9;
  color: #94a3b8;
}

.filter-chip--inactive:active {
  background: #e2e8f0;
}

.dev-list-area {
  padding: 0 12px 120px;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
}

.empty-state svg {
  margin-bottom: 16px;
}

.empty-text {
  font-size: 14px;
  color: #94a3b8;
  margin: 0;
}

.dialog-body {
  padding: 8px 20px 20px;
}

.dialog-label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  margin-bottom: 6px;
  padding-left: 2px;
}

.dialog-input-wrap :deep(.van-cell) {
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 10px 14px;
  min-height: 44px;
  transition: border-color 0.25s, box-shadow 0.25s, background 0.25s;
}

.dialog-input-wrap :deep(.van-cell:focus-within) {
  border-color: #2dd4bf;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(45, 212, 191, 0.08);
}

.dialog-input-wrap :deep(.van-field__body) {
  background: transparent;
}

.dialog-field {
  color: #1e293b !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  background: transparent !important;
}

.dialog-input-wrap :deep(.van-field__placeholder) {
  color: #cbd5e1 !important;
  font-weight: 400 !important;
}

.group-select-popup {
  padding: 20px 0 30px;
  min-height: 300px;
  background: #fff;
}

.group-select-popup .popup-title {
  font-size: 17px;
  font-weight: 600;
  color: #1e293b;
  text-align: center;
  margin: 0 0 16px;
  padding: 0 20px;
}
</style>